import { Tag } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { OrganizationInviteStatusV2Dto } from "../../../autogen/bff-api";

export const OrgInviteStatusTag = ({ status }: { status: OrganizationInviteStatusV2Dto }) => {
  const { t } = useTranslation();

  const tagMeta = (): { color: string; text: string } => {
    switch (status) {
      case OrganizationInviteStatusV2Dto.Accepted:
        return { color: "green", text: t("Accepted") };
      case OrganizationInviteStatusV2Dto.Declined:
        return { color: "red", text: t("Declined") };
      case OrganizationInviteStatusV2Dto.Invited:
        return { color: "gray", text: t("Invited") };
    }
  };

  const { color, text } = tagMeta();

  return (
    <Tag colorScheme={color} size="sm" textAlign="center" height="8" py="2">
      {text}
    </Tag>
  );
};
